import { lazy } from 'react';
import { RouteObject } from 'react-router';

// project import
import Loadable from 'components/Loadable';
import { MinimalLayout } from 'layout/MinimalLayout';

// render pages
const NotFoundRedirect = Loadable(
    lazy(() => import('pages/fallback/NotFoundRedirect')),
);

// ==============================|| STATIC ROUTING ||============================== //
const FallbackRoutes: RouteObject = {
    path: '*',
    element: <MinimalLayout />,
    children: [
        {
            path: '*',
            element: <NotFoundRedirect />,
        },
    ],
};

export default FallbackRoutes;
